import styled from 'styled-components';
import { Input } from 'ui-components/src/components/atoms/Input';
import { SingleSelect } from 'ui-components/src/components/atoms/Select/Single';

export const StyledInput = styled(Input)`
  margin-top: 1rem;
`;

export const StyledSelect = styled(SingleSelect)`
  margin-top: 16px;

  ul {
    top: 45px;
  }
`;
